'use strict';

var App = require('app');
var Misc = require('utils/misc');

var heatCircuits = [10, 20, 30, 110, 120, 130];

var HeatCircuit = Backbone.Model.extend({
    defaults: {
        modelType: 'circuit',
    },

    initialize: function (options) {
        this.deviceID = options.deviceID;
        this.circuitID = options.circuitID;
        this.requestType = options.requestType;
    },

    url: function () {
        var result = '/api/v1/devices/' + this.deviceID + '/circuits/' + this.circuitID + '/' + this.requestType;
        if (this.attributes.changedValue !== undefined) {
            result += '/' + this.attributes.changedValue;
        }
        return result;
    },

    getTimeDataBitArray: function (timeProgramNr) {
        var result = [];

        for (var i = 0; i < 7; ++i) {
            result.push(Misc.int2bitArray(this.attributes.time_programs[timeProgramNr].data[i]));
        }

        return result;
    },
});

var API = {
    getHeatCircuit: function (deviceID, circuitID, requestType) {
        var circuit = new HeatCircuit({
            deviceID: deviceID,
            circuitID: circuitID,
            requestType: requestType,
        });
        var defer = $.Deferred();

        circuit.fetch({
            success: function (data) {
                defer.resolve(data);
            },
            error: function (data) {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },
};

App.reqres.setHandler('circuit:model', function (deviceID, circuitID, requestType) {
    return API.getHeatCircuit(deviceID, circuitID, requestType);
});

module.exports = HeatCircuit;
